import videojs from 'video.js';
import utils from './share-utils.js';
const Component = videojs.getComponent('Component');
const ModalDialog = videojs.getComponent('ModalDialog');

const dom = videojs.dom || videojs;

const DEFAULTS = {
	soc_url: '',
	soc_networks: ['vk', 'facebook', 'twitter', 'odnoklassniki', 'mailru', 'whatsapp'],
	mobile_soc_networks: ['viber'],
	video_type: '',
	video_id: '',
	prefix: '$',
	page_url: '',
	share_url: '',
	icons_sprite_url: '',
	share_resolutions: '640x360,1280x720'
};

/**
 * The dialog component for showing moment Settings
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends ModalDialog
 */
class ShareSettings extends ModalDialog {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options); 
		options_.uncloseable = true;
		super(player, options_);
		this.playerPaused = true;
		this.hide();
		this.init();
	}

	setListeners_() {
		this.on(this.$('.vjs-share-settings-close'), 'click', () => {
			this.hide();
		});

		let scl_items = this.$$('.vjs-share-scl-item');
		for (let i = 0; i < scl_items.length; i++) {
			this.on(scl_items[i], 'click', (ev) => {
				window.open(this.getSocUrl(ev.target.closest('.vjs-share-scl-item').dataset.network), '_blank');
				if (!window.dataLayer) return;
			    window.dataLayer.push({
					event: 'event',
					eventCategory: 'cocacolakhl',
					eventAction: 'share_soc',
					eventLabel: ev.target.dataset.network
				});
			});
		}

		this.on(this.$('#vjs_share_sc_copy_link'), 'click', () => {
			utils.copyToClipboard(this.$('#vjs_share_sc_link_inp'), () => {
				this.$('#vjs_share_sc_copy_link span').innerHTML = this.localize("Share copied");
				this.$('#vjs_share_sc_copy_iframe').innerHTML = this.localize("Share copy code");
			});
		});

		this.on(this.$('#vjs_share_sc_copy_iframe'), 'click', () => {
			utils.copyToClipboard(this.$('#vjs_share_sc_code_inp'), () => {
				this.$('#vjs_share_sc_copy_iframe').innerHTML = this.localize("Share copied");
				this.$('#vjs_share_sc_copy_link span').innerHTML = this.localize("Share link copy");
			});
		});

		let other_items = this.$$('#vjs_share_sc_other_size .vjs-share-sc-inp');
		for (let i = 0; i < other_items.length; i++) {
			let item = other_items[i];
			this.on(item, 'keypress', (e) => {
				if (!this.validateSize(e.which)) e.preventDefault();
			});

			this.on(item, 'paste', (e) => {
				e.preventDefault();
				return false;
			});

			this.on(item, 'keyup', () => {
				this.$('#vjs_share_sc_gen').style.display = '';
				this.$('#vjs_share_sc_copy_iframe').style.display = 'none';
			});
		}

		this.on(this.$('#vjs_share_sc_link_inp_w'), 'keyup', (e) => {
			if (!this.validateSize(e.keyCode) || this.$('#vjs_share_sc_link_inp_h').value.includes('%')) return;
			let v = this.calcComplimentSize(e.target.value, null);
			v && (this.$('#vjs_share_sc_link_inp_h').value = v);
		});

		this.on(this.$('#vjs_share_sc_link_inp_h'), 'keyup', (e) => {
			if (!this.validateSize(e.keyCode) || this.$('#vjs_share_sc_link_inp_w').value.includes('%')) return;
			let v = this.calcComplimentSize(null, e.target.value);
			v && (this.$('#vjs_share_sc_link_inp_w').value = v);
		});

		this.on(this.$('#vjs_share_sc_sel'), 'change', () => {
			var el = this.$('#vjs_share_sc_sel'),
				other_size = el.options[el.selectedIndex].dataset.type == 'other';
			this.$('#vjs_share_sc_other_size').style.display = other_size ? '' : 'none';

			this.$('#vjs_share_sc_gen').style.display = '';
			this.$('#vjs_share_sc_copy_iframe').style.display = 'none';
		});

		this.on(this.$('#vjs_share_sc_gen'), 'click', () => {
			this.showCode();
		});		
	}

	init() {
		this.fillWith(this.createContent());
		this.setListeners_();
	}

	show() {
	    super.show();
	    this.playerPaused = this.player_.paused();
	    if (!this.playerPaused) {
			this.player_.pause();
	    }
	    this.clearFields();
	    if (!window.dataLayer) return;
	    window.dataLayer.push({
			event: 'event',
			eventCategory: 'cocacolakhl',
			eventAction: 'share_button',
			eventLabel: window.location.href
		});
	}

	hide() {
	    super.hide();
	    if (!this.playerPaused) {
			this.player_.play();
	    }
	}

	createContent() {
		return [
			this.createClose_(),
			this.createHeading_(), 
			this.createSocContent_()
		];
	}

	buildCSSClass() {
		return `vjs-share-settings ${super.buildCSSClass()}`;
	}

	getSocUrl(network) {
		return this.options_.soc_url.replace(`${this.options_.prefix}type`, this.options_.video_type)
			.replace(`${this.options_.prefix}social`, network)
			.replace(`${this.options_.prefix}id`, this.options_.video_id);
	}

	createClose_() {
		let close = dom.createEl('span', {
			className: 'vjs-share-settings-close'
		});
		if (this.options_.icons_sprite_url) {
			close.classList.add('vjs-share-settings-close_svg-sprite');
			close.insertAdjacentHTML(
				'afterbegin',
				`<svg viewBox="0 0 100 100"><use href="${this.options_.icons_sprite_url}#close" /></svg>`
			);
		} else {
			dom.insertContent(close, '\u00D7');
		}

		return close;
	}

	createHeading_() {
		let heading = dom.createEl('div', {
			className: 'vjs-share-settings-caption'
		}, {
			'role': 'heading'
		});
		dom.insertContent(heading, this.localize("Share settings"));
		return heading;
	}

	createSocContent_() {
		let content = dom.createEl('div', {
			className: 'vjs-share-settings-content'
		});
		dom.appendContent(content,
			[this.createSocList_(),
			this.createLinkShare_(), 
			this.createEmbedShare_()]);
		return content;
	}

	createSocList_() {
		let list = dom.createEl('div', {
			className: 'vjs-share-sc-list'
		});

		this.options_.soc_networks.forEach((n) => {
			dom.appendContent(list, this.createSocListItem_(n));
		});
		if (utils.isMobile()) {
			this.options_.mobile_soc_networks.forEach((n) => {
				dom.appendContent(list, this.createSocListItem_(n));
			});
		}
		return list;
	}

	createSocListItem_(network) {
		let item = dom.createEl('div', {
			className: `vjs-share-scl-item vjs-share-scl-item_${network}`
		}, {
			'data-network': network
		});

		if (this.options_.icons_sprite_url) {
			item.classList.add('vjs-share-scl-item_svg-sprite');
			item.insertAdjacentHTML(
				'afterbegin',
				`<svg viewBox="0 0 100 100"><use href="${this.options_.icons_sprite_url}#${network}" /></svg>`
			);
		}

		return item;
	}

	createLinkShare_() {
		if (!this.options_.page_url) return;

		let content = dom.createEl('div', {
			className: 'vjs-share-sc-link'
		});
		let txt = dom.createEl('span', {
			className: 'vjs-share-sc-txt'
		});
		dom.appendContent(txt, (this.localize("Share link") + ':'));

		let inp = dom.createEl('input', {
			id: 'vjs_share_sc_link_inp',
			className: 'vjs-share-sc-inp vjs-share-sc-inp_dashed'
		}, {
			type: 'text',
			readonly: true,
			value: this.options_.page_url
		});
		let copy = dom.createEl('span', {
			id: 'vjs_share_sc_copy_link',
			className: 'vjs-share-sc-act'
		});
		copy.appendChild(document.createElement('span'));
		if (this.options_.icons_sprite_url) {
			copy.classList.add('vjs-share-sc-act_svg-sprite');
			copy.insertAdjacentHTML(
				'afterbegin',
				`<svg viewBox="0 0 100 100"><use href="${this.options_.icons_sprite_url}#copy" /></svg>`
			);
		}
		dom.appendContent(content, [txt, inp, copy]);
		return content;
	}

	createEmbedShare_() {
		if (!this.options_.share_url) return;

		let content = dom.createEl('div', {
			className: 'vjs-share-sc-share'
		});
		let txt = dom.createEl('span', {
			className: 'vjs-share-sc-txt'
		});
		dom.appendContent(txt, (this.localize("Share iframe") + ':'));

		let sel = dom.createEl('select', {
			id: 'vjs_share_sc_sel',
			className: 'vjs-share-sc-sel'
		});

		(this.options_.share_resolutions || {}).split(',').forEach((s) => {
			dom.appendContent(sel, this.createShareSelItem_(s));
		});
		dom.appendContent(sel, this.createShareSelItem_(this.localize("Share other size"), 'other'));
		
		let gen = dom.createEl('span', {
			id: 'vjs_share_sc_gen',
			className: 'vjs-share-sc-act'
		});
		dom.appendContent(gen, this.localize("Share generate"));

		let copy = dom.createEl('span', {
			id: 'vjs_share_sc_copy_iframe',
			className: 'vjs-share-sc-act'
		});

		let spinner = dom.createEl('span', {
			id: 'vjs_share_sc_copy_spinner',
			className: 'vjs-share-sc-spinner vjs-loading-spinner'
		});

		dom.appendContent(content, [txt, sel, this.createShareOtherSize_(), gen, copy, this.createShareCodeInp_(), spinner]);
		return content;
	}

	createShareSelItem_(size, type) {
		let p = {
				'value': size
			}, item;

		if (type) p['data-type'] = type;
		item = dom.createEl('option', {}, p);
		dom.appendContent(item, size);
		return item;
	}

	createShareOtherSize_() {
		let content = dom.createEl('span', {
			id: 'vjs_share_sc_other_size',
			className: 'vjs-share-sc-other-size'
		});

		let w = dom.createEl('input', {
			id: 'vjs_share_sc_link_inp_w',
			className: 'vjs-share-sc-inp'
		}, {
			type: 'text',
			maxlength: '4'
		});

		let x = dom.createEl('span', {className: 'vjs-share-sc-x'});
		dom.appendContent(x, 'x');

		let h = dom.createEl('input', {
			id: 'vjs_share_sc_link_inp_h',
			className: 'vjs-share-sc-inp'
		}, {
			type: 'text',
			maxlength: '4'
		});

		dom.appendContent(content, [w, x, h]);
		return content;
	}

	createShareCodeInp_() {
		let inp = dom.createEl('input', {
			id: 'vjs_share_sc_code_inp',
			className: 'vjs-share-sc-inp vjs-share-sc-inp_large vjs-share-sc-inp_dashed'
		}, {
			type: 'text',
			readonly: true
		});
	
		return inp;
	}

	clearFields() {
		this.$('#vjs_share_sc_gen').style.display = '';
		this.$('#vjs_share_sc_copy_iframe').style.display = 'none';
		this.$('#vjs_share_sc_link_inp_w').setAttribute('value', '');
		this.$('#vjs_share_sc_link_inp_h').setAttribute('value', '');	
		this.$('#vjs_share_sc_sel').selectedIndex = 1;
		this.$('#vjs_share_sc_other_size').style.display = 'none';
		this.$('#vjs_share_sc_code_inp').style.display = 'none';
		this.$('#vjs_share_sc_copy_spinner').style.display = 'none';
		this.$('#vjs_share_sc_copy_link span').innerHTML = this.localize("Share link copy");
		this.$('#vjs_share_sc_copy_iframe').innerHTML = this.localize("Share copy code");
	}

	showCode() {
		this.$('#vjs_share_sc_copy_spinner').style.display = '';
		this.getCode().then((res) => {
			this.$('#vjs_share_sc_copy_spinner').style.display = 'none';
			this.$('#vjs_share_sc_gen').style.display = 'none';
			this.$('#vjs_share_sc_copy_iframe').style.display = '';
			this.$('#vjs_share_sc_copy_iframe').innerHTML = this.localize("Share copy code");
			this.$('#vjs_share_sc_code_inp').style.display = '';
			this.$('#vjs_share_sc_code_inp').value = res;
		}, (err) => {
			this.$('#vjs_share_sc_copy_spinner').style.display = 'none';
			this.$('#vjs_share_sc_gen').style.display = '';
			this.$('#vjs_share_sc_copy_iframe').style.display = 'none';
			this.$('#vjs_share_sc_code_inp').style.display = '';
			this.$('#vjs_share_sc_code_inp').value = this.localize("Share error");
		});
	}

	getCode() {
		let size = this.getSelectedSize();
		let link = `${this.options_.share_url}
			?id=${this.options_.video_id}&type=${this.options_.video_type}&method=iframe
			&width=${encodeURIComponent(size.w)}&height=${encodeURIComponent(size.h)}`;

		let p = new Promise((resolve, reject) => {
			videojs.xhr({uri: link}, 
			function (err, resp, body) {
				let code = resp && resp.rawRequest && resp.rawRequest.responseXML &&
					(resp.rawRequest.responseXML.childNodes[0] || '').textContent;

				if (resp.statusCode !== 200 || !code) {
					reject(err);
				} else {
					resolve(code);
				}	
			});
		});

		return p;
	}

	getSelectedSize() {
		let el = this.$('#vjs_share_sc_sel'),
			sel_opt = el.options[el.selectedIndex],
			other_size = sel_opt.dataset.type == 'other',
			w, h;

		if (other_size) {
			w = this.$('#vjs_share_sc_link_inp_w').value;
			h = this.$('#vjs_share_sc_link_inp_h').value;
		} else {
			[w, h] = (sel_opt.value ||'').split('x'); 
		}
		[w, h] = [w.trim(), h.trim()];

		return {w, h};
	}

	validateSize(key) {
		return (key == 8 || key == 37 || key == 0 || (key >= 48 && key <= 57)); // backsp || %
	}

	calcComplimentSize(w, h) {
		let vw = this.player_.videoWidth(),
			vh = this.player_.videoHeight(),
			aspect = vw && vh && vw/vh || 16/9;

		return Math.round(h ? h * aspect : w * 1/aspect);
	}
}

Component.registerComponent('ShareSettings', ShareSettings);
export default ShareSettings;